import createPersistedState from 'vuex-persistedstate'
import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";

Vue.use(Vuex);

const initState = {
  token: '',
  userInfo: null,
  ip: '',
  language: null,
  searchHistory: [],
  signWallet: 0,
  isShowLogin: false,
  aiTraderIsAdmin: null,
}

export default new Vuex.Store({
  state: initState,
  getters: {},
  mutations: {
    // 设置 token
    SET_TOKEN (state, data) {
      state.token = data;
    },
    // 设置用户信息
    SET_USER_INFO (state, data) {
      state.userInfo = data;
    },
    // 设置IP
    SET_IP (state, data) {
      state.ip = data;
    },
    // 设置语言
    SET_LANGUAGE (state, data) {
      state.language = data;
    },
    // 退出登录
    QUIT (state) {
      Object.assign(state, initState);
      // router.push('/');
    },
    // 设置是否显示登录
    SET_IS_SHOW_LOGIN (state, data) {
      state.isShowLogin = data;
    },
    // 设置签到钱包余额
    SET_SIGN_WALLET (state, data) {
      state.signWallet = data;
    },

    // 设置 AI 交易员管理权限标志
    SET_AI_TRADER_IS_ADMIN (state, data) {
      state.aiTraderIsAdmin = !!data;
    },

    // 添加历史搜索记录
    SET_SEARCH_HISTORY (state, data) {
      if (!state.searchHistory.includes(data)) {
        state.searchHistory.unshift(data);
      }
    },
    // 删除历史搜索记录
    DEL_SEARCH_HISTORY (state) {
      state.searchHistory = [];
    },
  },
  plugins: [createPersistedState({
    // Never restore login modal visibility across reloads.
    paths: ['token', 'userInfo', 'ip', 'language', 'searchHistory', 'signWallet'],
  })]
});
